import { render, staticRenderFns } from "./Edit-Doc-File.vue?vue&type=template&id=ba4b0d8e&scoped=true&"
import script from "./Edit-Doc-File.vue?vue&type=script&lang=js&"
export * from "./Edit-Doc-File.vue?vue&type=script&lang=js&"
import style0 from "./Edit-Doc-File.vue?vue&type=style&index=0&id=ba4b0d8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4b0d8e",
  null
  
)

export default component.exports